// src/pages/LoginSign/components/molecules/MoleculeLoginForm.jsx
import React, { useEffect, useState } from "react";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import styled, { css, ThemeProvider } from "styled-components";
import theme from "../../../../assets/styles/Theme";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { isValidEmail } from "../atoms/AtomValidation";
import {
  UserCreditInfo,
  loginNormal,
  loginMarketing,
  getUserInfo,
  getUserMemberType,
  getEduBoardListOnServer,
} from "../../../../utils/indexedDB";
import { CustomInput } from "../../../../assets/styles/InputStyle";
import images from "../../../../assets/styles/Images";
import { EMAIL, ERROR_STATUS, ACCESSABLE_EXPERT } from "../../../AtomStates";
import {
  IS_LOGGED_IN,
  LOGIN_SUCCESS,
  USER_NAME,
  USER_EMAIL,
  IS_MARKETING,
  CONVERSATION_ID,
  USER_MEMBERSHIP,
  IS_SIGNUP_POPUP_OPEN,
  USER_CREDITS,
  EDUCATION_STATE,
  ADMIN_STATE,
  MEMBER_TYPE,
} from "../../../../pages/AtomStates";
import { Link } from "react-router-dom";
import { palette } from "../../../../assets/styles/Palette";
import MoleculeResetPasswordPopup from "./MoleculeResetPasswordPopup";

const MoleculeLoginForm = ({ onClosePopup }) => {
  const [, setUserCredits] = useAtom(USER_CREDITS);
  const [email, setEmail] = useAtom(EMAIL);
  const [, setUserMembership] = useAtom(USER_MEMBERSHIP);
  const [educationState, setEducationState] = useAtom(EDUCATION_STATE);
  const [adminState, setAdminState] = useAtom(ADMIN_STATE);
  const [password, setPassword] = useState("");
  const [errorStatus, setErrorStatus] = useAtom(ERROR_STATUS);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [, setIsLoggedIn] = useAtom(IS_LOGGED_IN);
  const [, setLoginSuccess] = useAtom(LOGIN_SUCCESS);
  const [, setUserName] = useAtom(USER_NAME);
  const [, setUserEmail] = useAtom(USER_EMAIL);
  const [isMarketing] = useAtom(IS_MARKETING);
  const [conversationId] = useAtom(CONVERSATION_ID);
  const [memberType, setMemberType] = useAtom(MEMBER_TYPE);

  const [showMobileWarning, setShowMobileWarning] = useState(false);
  const [, setAccessableExpert] = useAtom(ACCESSABLE_EXPERT);
  const [isSignPopupOpen] = useAtom(IS_SIGNUP_POPUP_OPEN); // 회원가입 팝업 상태 관리
  const [isPasswordRestPopupOpen, setIsPasswordRestPopupOpen] = useState(false); // 비밀번호 리셋 팝업 상태 관리
  const [, setIsExitPopupOpen] = useState(false);

  useEffect(() => {
    setErrorStatus("");
  }, [setErrorStatus]);

  const validateForm = () => {
    if (!email || !password) {
      setErrorStatus("모든 필드를 입력해주세요.");
      return false;
    }
    if (!isValidEmail(email)) {
      setErrorStatus("유효한 이메일 주소를 입력해주세요.");
      return false;
    }
    return true;
  };

  const handleExitCancel = () => {
    setIsExitPopupOpen(false);
  };

  const handleLogin = async () => {
    setErrorStatus("");
    if (!validateForm()) return;

    try {
      let result;

      result = await loginNormal(email, password);

      const accessToken = result.access_token;
      sessionStorage.setItem("accessToken", accessToken);

      // 기기 타입 감지 및 저장 (로그인 시점)
      const DeviceDetectionService = (
        await import("../../../../utils/DeviceDetectionService")
      ).default;
      const deviceType = DeviceDetectionService.detectDevice();
      DeviceDetectionService.saveToSession(deviceType);
      console.log("🔐 로그인 시 기기 감지 및 저장:", deviceType);

      const userInfo = await getUserInfo(accessToken);

      // const userMemberType = await getUserMemberType(accessToken);

      // 유저 정보 저장
      setUserName(userInfo.name);
      setUserEmail(userInfo.email);
      setUserMembership(userInfo.membership);
      setEducationState(userInfo.education_state);
      setAdminState(userInfo.is_admin);
      setMemberType(userInfo.member_type);
      sessionStorage.setItem("userName", userInfo.name);
      sessionStorage.setItem("userEmail", userInfo.email);
      sessionStorage.setItem("userCreatedAt", userInfo.signup_date);

      setIsLoggedIn(true);
      setLoginSuccess(true);

      // 3으로 시작하는 멤버 타입들은 바로 목적지로 이동 (디바이스 선택 건너뛰기)
      const memberTypeStr = String(userInfo.member_type);
      if (memberTypeStr.startsWith("3")) {
        const eduBoardList = await getEduBoardListOnServer(999, 1, true);

        if (userInfo.member_type === 31) {
          // 현재 사용자의 이메일과 일치하는 manager 개수 확인
          const userEmail = userInfo.email;
          const managedBoards = eduBoardList.data.filter(
            (board) => board.manager === userEmail
          );
          const managedBoardsCount = managedBoards.length;

          if (managedBoardsCount === 1) {
            sessionStorage.setItem("customerId", managedBoards[0]._id);
            navigate("/EducationDashBoard");
          } else if (managedBoardsCount >= 2) {
            navigate("/EduboardManage");
          } else {
            navigate("/EduboardManage");
          }
        } else if (userInfo.member_type === 32) {
          navigate("/EducationDashBoard");
        }
      } else if (userInfo.member_type === 99) {
        navigate("/Admin");
      } else if (userInfo.member_type === 12 || userInfo.member_type === 22) {
        navigate("/CustomerManage");
      } else if (userInfo.member_type === 11) {
        navigate("/DashBoard");
      } else if (userInfo.member_type === 21) {
        navigate("/ApiDashBoard");
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setErrorStatus(error.response.data.message);
      } else {
        setErrorStatus("로그인 중 오류가 발생했습니다.");
      }
    }
  };
  // const validateEmail = (email) => {
  //   if (!isValidEmail(email)) {
  //     setErrorStatus("유효한 이메일 주소를 입력해주세요.");
  //     setIsEmailValid(false);
  //     setIsCommercialEmail(false);
  //     return;
  //   }

  //   // 상용 이메일 체크 로직 추가
  //   const commonEmailDomains = [
  //     "gmail.com",
  //     "yahoo.com",
  //     "yahoo.co.jp",
  //     "hotmail.com",
  //     "outlook.com",
  //     "aol.com",
  //     "zoho.com",
  //     "mail.com",
  //     "mail.ru",
  //     "gmx.com",
  //     "yandex.com",
  //     "protonmail.com",
  //     "icloud.com",
  //     "fastmail.com",
  //     "hushmail.com",
  //     "inbox.com",
  //     "lycos.com",
  //     "rediffmail.com",
  //     "mail.ru",
  //     "qq.com",
  //     "163.com",
  //     "126.com",
  //     "sina.com",
  //     "sohu.com",
  //     "yeah.net",
  //     "21cn.com",
  //     "tom.com",
  //     "foxmail.com",
  //     "live.com",
  //     "msn.com",
  //     "naver.com",
  //     "daum.net",
  //     "nate.com",
  //     "kakao.com",
  //     "hanmail.net",
  //     "korea.com",
  //     "hanmir.com",
  //     "empal.com",
  //     "hitel.net",
  //     "kebi.com",
  //     "netian.com",
  //     "dreamwiz.com",
  //     "tistory.com",
  //     "naver.com",
  //     "daum.net",
  //     "nate.com",
  //     "orgio.net",
  //     "wail.co.kr",
  //     "lycos.co.kr",
  //     "chol.com",
  //     "chollian.net",
  //     "intizen.com",
  //     "freechal.com",
  //     "teramail.com",
  //     "metq.com",
  //     "paran.com",
  //     "cyworld.com",
  //     "hanafos.com",
  //     "unitel.co.kr",
  //   ];
  //   const emailDomain = email.split("@")[1];
  //   if (commonEmailDomains.includes(emailDomain)) {
  //     setErrorStatus("상용 이메일은 사용할 수 없습니다.");
  //     setIsEmailValid(false);
  //     setIsCommercialEmail(true);
  //     return;
  //   }

  //   setIsEmailValid(true);
  //   setIsCommercialEmail(false);
  //   setErrorStatus("");
  // };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handlePasswordReset = (event) => {
    // event.preventDefault(); // 기본 동작 방지
    navigate("/request-reset-password");
  };

  const handleMobileWarningConfirm = () => {
    // console.log("🚀 ~ handleMobileWarningConfirm ~ handleMobileWarningConfirm");
    setShowMobileWarning(false);
    setLoginSuccess(true); // 확인 버튼 클릭 시 로그인 성공 처리
    navigate("/Project");
  };

  // const handleSignupClick = (e) => {
  //   e.preventDefault();
  //   setIsSignupPopupOpen(true);
  // };

  // const handleClosePopup = () => {
  //   setIsSignupPopupOpen(false);
  // };

  // const handleSignClick = () => {
  //   setIsSignPopupOpen(true); // 회원가입 팝업 열기
  //   setIsLoginPopupOpen(false);
  //   onClosePopup();
  // };
  // const closeSignPopup = () => {
  //   setIsSignPopupOpen(false); // 회원가입 팝업 닫기
  //   setErrorStatus("");
  //   setSignUpName("");
  //   setEmail("");
  //   setSignupEmail("");
  //   setPassword("");
  //   setSignupPassword("");
  //   setConfirmPassword("");
  // };

  const handlePasswordRestClick = () => {
    setIsPasswordRestPopupOpen(true); // 비밀번호 리셋 팝업 열기
  };
  const closePasswordRestPopup = () => {
    setIsPasswordRestPopupOpen(false); // 비밀번호 리셋 팝업 닫기
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleLogin();
    }
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        {/* 팝업이 열리면 로그인 폼은 숨기고 팝업만 표시 */}
        {isSignPopupOpen || isPasswordRestPopupOpen ? null : (
          <LoginFormContainer>
            <div>
              <label htmlFor="email">
                아이디<span>*</span>
              </label>
              <CustomInput
                Small
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="입력해주세요"
              />
            </div>

            <div>
              <label htmlFor="password">
                비밀번호<span>*</span>
              </label>
              <CustomInput
                Small
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyPress}
                placeholder="입력해주세요"
              />

              <TogglePasswordButton onClick={togglePasswordVisibility}>
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </TogglePasswordButton>
            </div>

            <PasswordResetLink>
              {/* <a onClick={handlePasswordRestClick}>비밀번호 찾기</a> */}
            </PasswordResetLink>

            <StyledLoginButton
              onClick={handleLogin}
              disabled={!email || !password}
            >
              로그인
            </StyledLoginButton>

            {errorStatus && <ErrorMessage>{errorStatus}</ErrorMessage>}

            <BusinessInfoWrap>
              <p>비즈니스 회원 전용 서비스입니다</p>
              <a
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate("/SignupAutodisplay");
                }}
              >
                가입 문의하기
              </a>
            </BusinessInfoWrap>
          </LoginFormContainer>
        )}
        {/* 비밀번호 재설정 팝업 */}
        {isPasswordRestPopupOpen && (
          <MoleculeResetPasswordPopup onClose={closePasswordRestPopup} />
        )}{" "}
        {/* 모바일 경고 팝업 */}
        {showMobileWarning && (
          <Popup Cancel>
            <div>
              <button
                type="button"
                className="closePopup"
                onClick={handleExitCancel}
              >
                닫기
              </button>
              <span>
                <img src={images.ExclamationMark} alt="" />
              </span>
              <p>
                <strong>본 서비스는 웹 전용으로 운영되고 있습니다.</strong>
                <span>웹에서 최적의 작업을 진행하세요</span>
              </p>
              <div className="btnWrap">
                <button type="button" onClick={handleMobileWarningConfirm}>
                  확인
                </button>
              </div>
            </div>
          </Popup>
        )}
      </ThemeProvider>
    </>
  );
};
export default MoleculeLoginForm;

const LoginFormContainer = styled.div`
  width: 100%;

  > div {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;

    label {
      font-size: 0.75rem;
      text-align: left;
      display: flex;
      align-items: flex-start;
      gap: 5px;

      span {
        color: ${palette.red};
      }
    }

    + div {
      margin-top: 20px;
    }
  }
`;

// const StyledAtomInput = styled.input`
//   width: 100%;
//   font-family: "Pretendard", "Poppins", sans-serif;
//   // font-size: 1rem;
//   font-size: 0.75rem;
//   padding: 12px 16px;
//   border-radius: 8px;
//   border: 1px solid ${palette.lineGray};
//   box-sizing: border-box;

//   &::placeholder {
//     font-size: 0.75rem;
//   }
// `;

const TogglePasswordButton = styled.button`
  position: absolute;
  right: 10px;
  bottom: 0;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-family: "Pretendard", "Poppins";
  color: #888;

  &:focus {
    outline: none;
  }
`;

const ErrorMessage = styled.p`
  font-size: 0.75rem;
  color: ${palette.red};
  margin-top: 20px;
  text-align: center;
`;

const PasswordResetLink = styled.div`
  margin: 20px auto 20px;
  text-align: right;
  cursor: pointer;

  a {
    color: ${palette.gray};
    font-size: 0.75rem;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const StyledLoginButton = styled.button`
  width: 100%;
  font-family: "Pretendard", "Poppins";
  color: ${palette.white};
  padding: 14px 16px;
  border-radius: 8px;
  border: none;
  background-color: ${palette.primary};
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    background: #d0d6e1;
    color: #ffffff;
    pointer-events: none;
  }
`;

const BusinessInfoWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row !important;
  gap: 12px;
  font-size: 1rem;
  color: ${palette.gray};
  margin-top: 40px;

  p {
    font-weight: 500;
    color: #7a7a7a;
    margin: 0;
  }

  a {
    color: #0453f4;
    text-decoration: underline;
    font-weight: 700;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-top: 20px;
  }
`;

const Popup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.5s;
  z-index: 9999;

  .closePopup {
    position: absolute;
    right: 24px;
    top: 24px;
    width: 16px;
    height: 16px;
    font-size: 0;
    padding: 9px;
    border: 0;
    background: none;

    &:before,
    &:after {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 2px;
      height: 100%;
      border-radius: 10px;
      background: ${palette.gray500};
      content: "";
    }

    &:before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  > div {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;
    text-align: center;
    // overflow:hidden;
    padding: 45px 24px 24px;
    border-radius: 10px;
    background: ${palette.white};

    p {
      font-family: "Pretendard", "Poppins";
      font-size: 0.875rem;
      font-weight: 500;
      margin: 20px auto 24px;
      strong {
        font-weight: 500;
        display: block;
      }

      span {
        font-size: 0.75rem !important;
        font-weight: 400;
        color: #8c8c8c;
        display: block;
        margin-top: 8px;
      }
    }

    .btnWrap {
      display: flex;
      align-items: center;
      gap: 16px;

      button {
        flex: 1;
        font-family: "Pretendard", "Poppins";
        font-size: 0.875rem;
        font-weight: 600;
        color: ${palette.blue};
        padding: 12px 20px;
        border-radius: 12px;
        border: 1px solid ${palette.blue};
        background: ${palette.white};

        // &:last-child {
        //   color: ${palette.white};
        //   background: ${palette.blue};
        // }
      }
    }

    ${(props) =>
      props.Cancel &&
      css`
        p {
          strong {
            font-weight: 600;
            display: block;
            color: ${palette.gray800};
          }
          span {
            font-size: 1rem;
            display: block;
            margin-top: 8px;
          }
        }

        .btnWrap {
          padding-top: 16px;
          border-top: 1px solid ${palette.lineGray};

          button {
            color: ${palette.gray700};
            font-weight: 400;
            padding: 0;
            border: 0;
            background: none;
          }
        }
      `}
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    > div {
      width: 90%;
    }
  }
`;
